// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__JEQq+","header":"NotFoundPage_header__y7u7F","info":"NotFoundPage_info__TEaIA","button":"NotFoundPage_button__CCCqU"};